import styled from "styled-components";
import { Column } from "styled/alignment/Column";
import breakpoints from "theme/breakpoints";

const ProductCardsContainer = styled(Column)`
    width: 100%;
    gap: 1rem;

    @media screen and (min-width: ${breakpoints.md}){
        flex-direction: row;
        flex-wrap: wrap;
    }
`;

const ContentProductCard = styled.div`
    width: 100%;
    display: flex;
    cursor: pointer;

    @media screen and (min-width: ${breakpoints.md}){
        width: 48%;
    }
    @media screen and (min-width: ${breakpoints.lg}){
        width: 31.5%;
    }
    @media screen and (min-width: ${breakpoints.xl}){
        width: 23.5%;
    }

    transition: all ease-in-out .25s;

    &:hover {
        transform: scale(1.01)
    }
`;

export {
    ProductCardsContainer,
    ContentProductCard
}